import i18n from "../../services/localization-service/i18n";
import { ActionMenuItem, BaseActions } from "../action-menu/ActionMenuItem";
import { AddIcon } from "../action-menu/ActionMenuIcons";

export enum ScheduleActions  {
    Add = 'add',
    Edit = 'edit',
    Delete = 'delete'
}

export type ScheduleActionItem = {
    action: ScheduleActions | BaseActions | string
} & ActionMenuItem;

export const tierActionItems: ScheduleActionItem[] = [{
    label: i18n.t("actions.chooseSchedule"),
    icon: AddIcon,
    action: ScheduleActions.Add,
    order: 0
}];




